export default async () => {
    document.addEventListener('DOMContentLoaded', equalizeItems)
    window.addEventListener('resize', equalizeItems)
    function equalizeItems() {
      let items = document.querySelectorAll('.testimonials .item')
      if (window.innerWidth > 767) {
        let max = 0
        items.forEach(i => i.style.height = 'auto')
        items.forEach(i => { if (i.offsetHeight > max) max = i.offsetHeight })
        items.forEach(i => i.style.height = max + 'px')
      } else {
        items.forEach(i => i.style.height = 'auto')
      }
    }
  }
  